<template>
  <div
    class="fx-column fx-row-center"
    style="width: 100vw; background: #F3F4F6; "
    :class="ISphone ? smallh2label : bigh3label"
    :style="{backgroundImage: 'url(' + 'http://pic.midongtech.xyz/yytgw/assets/img_contact_bg_banner.jpg' + ')',
     backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"
  >
    <div
      v-if="ISphone"
      style=" margin-top: 8vw;  margin-bottom: 4vw; color:#16214B;"
      :class="ISphone ? smallh1label : 'bigh1labelnobold'"
    >请留下您的联系方式，我们会马上联系您</div>

    <div
      v-else
      style=" margin-top: 4vw; color:#16214B;"
      :class="ISphone ? smallh1label : 'bigh1labelnobold'"
    >请留下您的联系方式，我们会马上联系您</div>

    <!-- 手机上 全部垂直 -->
    <div v-if="ISphone" class="fx-column fx-row-center">
      <div style="width: 90%;  margin-top: 1vw;" class="fx-column">
        <div style="text-align: left;  ">* 您的称呼</div>
        <div style="width: 100%; margin-top: 10px;">
          <el-input v-model="name" placeholder="请填写全名"></el-input>
        </div>
      </div>

      <div style="width: 90%;  margin-top: 1vw;" class="fx-column">
        <div style="text-align: left;  ">* Email</div>
        <div style="width: 100%; margin-top: 10px;">
          <el-input v-model="email" placeholder="****@email.com"></el-input>
        </div>
      </div>

      <div style="width: 90%;  margin-top: 1vw;" class="fx-column">
        <div style="text-align: left;  ">* 手机号码</div>
        <div style="width: 100%; margin-top: 10px;">
          <el-input v-model="phone" placeholder="11位手机号码"></el-input>
        </div>
      </div>

      <div style="width: 90%;  margin-top: 1vw;" class="fx-column">
        <div style="text-align: left;  ">我想了解</div>
        <div style="width: 100%; margin-top: 10px;">
          <el-input v-model="type" placeholder="广告变现"></el-input>
        </div>
      </div>

      <div style="width: 90vw; text-align: left; margin-top: 1vw;  ">其他信息</div>
      <!--    v-model="textarea"-->
      <div style="width: 90vw;margin-top: 1vw;  ">
        <el-input
          type="textarea"
          v-model="content"
          placeholder="如果有其他信息或者建议,请务必写下,我们会尽快联系您"
          :rows="10"
        ></el-input>
      </div>
    </div>

    <div v-else>
      <div
        class="fx-row fx-row-center fx-wrap fx-row-space-between"
        style="width: 75vw; margin-top: 3vw; "
      >
        <div style="width: 45%;  margin-top: 1vw;" class="fx-column">
          <div style="text-align: left;  ">* 您的称呼</div>
          <div style="width: 100%; margin-top: 10px;">
            <el-input v-model="name" placeholder="请填写全名"></el-input>
          </div>
        </div>

        <div style="width: 45%;  margin-top: 1vw;" class="fx-column">
          <div style="text-align: left;  ">* Email</div>
          <div style="width: 100%; margin-top: 10px;">
            <el-input v-model="email" placeholder="****@email.com"></el-input>
          </div>
        </div>

        <div style="width: 45%;  margin-top: 1vw;" class="fx-column">
          <div style="text-align: left;  ">* 手机号码</div>
          <div style="width: 100%; margin-top: 10px;">
            <el-input v-model="phone" placeholder="11位手机号码"></el-input>
          </div>
        </div>

        <div style="width: 45%;  margin-top: 1vw;" class="fx-column">
          <div style="text-align: left;  ">我想了解</div>
          <div style="width: 100%; margin-top: 10px;">
            <el-input v-model="type" placeholder="广告变现"></el-input>
          </div>
        </div>
      </div>

      <div style="width: 75vw; text-align: left; margin-top: 1vw;  ">其他信息</div>
      <!--    v-model="textarea"-->
      <div style="width: 75vw;margin-top: 1vw;  ">
        <el-input
          type="textarea"
          v-model="content"
          placeholder="如果有其他信息或者建议,请务必写下,我们会尽快联系您"
          :rows="10"
        ></el-input>
      </div>
    </div>

    <div
      :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
      class="darkbuttoncolor hvr_grow_shadow"
      @click="contackclick"
    >立即联系</div>
  </div>
</template>
<script type="text/ecmascript-6">
import md5 from "md5";

import qs from "qs";

import { Message } from "element-ui";

export default {
  name: "contactusview",
  // components: {Message},

  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      secarray: [
        {
          titlestr: "* 您的称呼",
          placeholder: "请填写全名"
          //  name:"",
        },
        {
          titlestr: "* Email",
          placeholder: "****@email.com"
          // email:"",
        },
        {
          titlestr: "* 手机号码",
          placeholder: "11位手机号码"
          //  phone:"",
        },
        {
          titlestr: "我想了解",
          placeholder: "广告变现"
          // type:"",
        }
      ],

      // name	是	string	姓名
      // email	是	string	邮箱
      // phone	是	string	电话
      // type	是	string	类型
      // content	是	string	内容

      name: "",
      email: "",
      phone: "",
      type: "",

      content: ""
    };
  },
  mounted() {
    //可用于设置自适应屏幕，根据获得的可视宽度（兼容性）判断是否显示
    let w = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (w < 1000) {
      this.ISphone = true;
    }
  },
  methods: {
    /**
     * 点击事件
     */
    contackclick() {
      console.log("点击了提交");

      // || this.$Tools.judgeNull(this.content)
      if (
        this.$Tools.judgeNull(this.name) ||
        this.$Tools.judgeNull(this.email) ||
        this.$Tools.judgeNull(this.phone) ||
        this.$Tools.judgeNull(this.type)
      ) {
        // this.$message({
        //   message: "请填写完整",
        //   type: "warning"
        // });

        Message({
          message: "请填写信息完整",
          type: "warning",
          offset: 80
        });

        return;
      }

      //  web/feedback

      //        time	是	string	时间
      // name	是	string	姓名
      // email	是	string	邮箱
      // phone	是	string	电话
      // type	是	string	类型
      // content	是	string	内容
      // sign	是	string	签名，md5(key + time),time是时间戳，key=mOIryqPUrnI6hDZq

      let that = this;
      let times = Date.parse(new Date());
      let MD5str = this.$Tools.getmd5key() + times;
      console.log("加密前==" + MD5str);

      let signstr = md5(MD5str);
      console.log("加密后==" + signstr);
      //填写参数
      let prama = {
        time: times,
        name: this.name,
        email: this.email,
        phone: this.phone,
        type: this.type,
        content: this.content,
        sign: signstr
      };
      // application/x-www-form-urlencoded
      //  this.$axios({
      //     headers: {
      //       "Content-Type": "application/json"
      //     },
      //     method: "post",
      //     url: that.$Tools.getBaseURL() + "web/feedback",
      //     data: prama
      //   })

      this.$axios({
        url: that.$Tools.getBaseURL() + "web/feedback",
        method: "post",
        data: qs.stringify(prama),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })

        .then(function(response) {
          let res = response.data;

          console.log("res=====" + JSON.stringify(res));

          // let msg = res.msg;
          let code = res.code;
          let type = "warning";
          let msg = res.msg;
          let offset = 80;
          if (code == "1") {
            type = "success";
            msg = "预约成功！感谢您的预约，稍后会有专业人员与您联系。";
          }

          if (that.ISphone) {
            offset = 180;
          }

          // that.$message({
          //   message: res.msg
          // });

          Message({
            message: msg,
            type: type,
            offset: offset
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped></style>
